<app-navbar></app-navbar>
<h2 class="text-center mt-3 mb-3">
    {{ 'Choose portal' | translate }}
</h2>
@if (portals.length > 9) {
    <div class="custom-search">
        <input
            class="form-control"
            type="text"
            [(ngModel)]="searchName"
            (ngModelChange)="search(searchName)"
            placeholder="{{ 'Search' | translate }}" />
        @if (searchName.length > 0) {
            <i (click)="clearSearchName()" class="fa fa-times custom-search-clear"></i>
        }
    </div>
}
@if (portals.length) {
    <div class="custom-list-wrapper">
        <div class="list-group">
            @for (portal of filteredPortals; track portal) {
                <a
                    [routerLink]="['/', communityName, portal.name, 'requests']"
                    class="list-group-item list-group-item-action d-flex align-items-center">
                    <div class="portal-logo">
                        @if (portal.logoUrl) {
                            <img class="portal-logo-img" src="{{ portal.logoUrl }}" />
                        }
                    </div>
                    <div class="portal-name">
                        {{ portal.name }}
                    </div>
                </a>
            }
            @if (!filteredPortals.length) {
                <div class="alert d-inline-block text-center">
                    {{ 'Portals not found' | translate }}
                </div>
            }
        </div>
    </div>
}
@if (!portals.length) {
    <div class="text-center">
        <div class="alert d-inline-block">
            {{ 'There are no portals. You can create new portal' | translate }}
            <a [href]="newPortalLink"> {{ 'here' | translate }} </a>.
        </div>
    </div>
}
